'use client';

import { useEffect } from 'react';
import { logAnalyticsEvent } from '@/lib/actions/analytics';

/**
 * Logs a `recipe_view` analytics event when a recipe detail page mounts. Lives
 * in a client component because recipe pages are ISR-cached — the server render
 * can't reliably log per-visit. Fires once per mount (a re-visit is a new
 * view). Renders nothing.
 */
export function RecipeViewBeacon({ recipeId }: { recipeId: string }) {
  useEffect(() => {
    void logAnalyticsEvent({
      eventType: 'recipe_view',
      recipeId,
      path: window.location.pathname,
    });
  }, [recipeId]);

  return null;
}
